import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Component Imports
import { UpgradePopUp } from "../../commonComponents";

import { FEATURES } from "../../constants";

const { FEATURES_NAME } = FEATURES;

class AddPbookBtnTnB extends Component {
  state = { showTnbPopup: false };

  _openTnbPopup = () => {
    this.setState({ showTnbPopup: true });
  };

  _closeTnbPopup = () => {
    this.setState({ showTnbPopup: false });
  };

  render() {
    return (
      <Fragment>
        {this.state.showTnbPopup && (
          <UpgradePopUp
            featureName={FEATURES_NAME.PRICEBOOK_ADD_PRICEBOOK}
            onClose={this._closeTnbPopup}
          />
        )}
        <div
          tabIndex={0}
          role="button"
          className="add-pricebook-card"
          data-test="addpricebook-btntnb-pricebook-section"
          onClick={() => this._openTnbPopup()}
          onKeyDown={() => {}}>
          <div className="add-pricebook-section">
            <div className="add-icon">
              <FontAwesomeIcon icon={["far", "plus"]} />
            </div>
            <div className="add-text">Create New Price Book</div>
          </div>
          <div
            className="pricelistcard-section"
            data-test="addpricebooktnb-pricelistcard-section">
            <span className="pricelistcard-tnb-label">PRO</span>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default AddPbookBtnTnB;



// WEBPACK FOOTER //
// ./src/componentsTnb/AddPbookBtnTnB/AddPbookBtnTnB.js